app.controller('exerciseAdd', function ($scope) {
    $scope.exerciseAdd = {
        currentForm: null,
        setCurrentForm: function(newForm, $event) {
            $event.preventDefault();
            $scope.exerciseAdd.currentForm = newForm;
        }
    };
});